module.exports = __webpack_public_path__ + "static/mainhero-7e78331a814d203043c5cb27225eac15.jpeg";